import _Fab from "@mui/material/Fab";
import _Tooltip from "@mui/material/Tooltip";
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { styled, ThemeProvider } from 'styled-components';
export class ButtonControl {
  constructor(id, options, callback) {
    this.id = id;
    this.options = options;
    this.callback = callback;
  }
  onAdd(_map) {
    this.map = _map;
    this.container = document.createElement('div');
    this.container.className = 'maplibregl-ctrl';
    const content = document.createElement('div');
    content.id = this.id;
    this.container.appendChild(content);
    this.root = createRoot(this.container);
    return this.container;
  }
  init(theme, options = {}) {
    this.theme = theme;
    this.update(options);
  }
  update(options = {}, callback) {
    if (!this.theme) return;
    const {
      ariaControls,
      ariaHasPopup,
      className,
      title,
      tooltipPlacement,
      color,
      icon,
      size,
      variant
    } = this.options = {
      ...this.options,
      ...options
    };
    if (callback) this.callback = callback;
    if (!this.root) return;
    this.root.render(/*#__PURE__*/React.createElement(MuiThemeProvider, {
      theme: this.theme
    }, /*#__PURE__*/React.createElement(ThemeProvider, {
      theme: this.theme
    }, variant === 'extended' ? /*#__PURE__*/React.createElement(StyledFab, {
      "aria-controls": ariaControls,
      "aria-haspopup": ariaHasPopup,
      className: className,
      color: color,
      onClick: event => this.map ? this.callback(this.map, event) : undefined,
      size: size || 'small',
      style: {
        textTransform: 'initial'
      },
      variant: "extended"
    }, icon, /*#__PURE__*/React.createElement("span", {
      style: {
        marginLeft: 8
      }
    }, title)) : /*#__PURE__*/React.createElement(_Tooltip, {
      placement: tooltipPlacement || 'left',
      title: title
    }, /*#__PURE__*/React.createElement(StyledFab, {
      "aria-controls": ariaControls,
      "aria-haspopup": ariaHasPopup,
      "aria-label": title,
      className: className,
      color: color,
      onClick: event => this.map ? this.callback(this.map, event) : undefined,
      size: size || 'small'
    }, icon)))));
  }

  /**
   * Spins the icon in place. Goes straight to the DOM rather than through `update`: this runs on
   * every frame of a map rotation, and re-rendering the React tree that often is wasteful.
   */
  setIconRotation(degrees) {
    const icon = this.container?.querySelector('svg');
    if (icon) icon.style.transform = `rotate(${degrees}deg)`;
  }
  onRemove() {
    this.container?.parentNode?.removeChild(this.container);
    this.map = undefined;
  }
}
const StyledFab = styled(_Fab)`
  && {
    &:not(:disabled):not(.MuiFab-primary):not(.MuiFab-secondary) {
      background-color: #fff;
    }

    &:not(:disabled):not(.MuiFab-primary):not(.MuiFab-secondary):hover {
      background-color: #d5d5d5;
    }

    &.MuiFab-primary:hover {
      background-color: ${({
  theme
}) => theme.palette.primary.dark};
    }

    &.MuiFab-secondary:hover {
      background-color: ${({
  theme
}) => theme.palette.secondary.dark};
    }
  }
`;